import React, { useMemo, useState } from 'react'
import './index.less'
import { Input, Tabs, Empty, Radio } from 'antd'
import ArticleList from '../components/list'
import { useParams } from 'react-router-dom'

import { effect, useStore } from '../../dva16'
import { NInfo, EGetSearch } from '../../models/constants'
import HotArticle from '../components/hotArticle'

const { TabPane } = Tabs
const data = [
  { title: '帝业2020过年放假通知及各部门安全准备' },
  { title: '帝业2020过年放假通知及各部门安全准备' },
  { title: '帝业2020过年放假通知及各部门安全准备' },
  { title: '帝业2020过年放假通知及各部门安全准备' },
]

function Search() {
  let { keyWord } = useParams()
  let { searchList, searchCategoryCount } = useStore(NInfo)
  const [query, setQuery] = useState(null)
  const [categoryID, setCategoryID] = useState(null)

  useMemo(() => {
    setQuery(keyWord)
    effect(NInfo, EGetSearch, { query: keyWord })
  }, [])

  const handleKeyUp = e => {
    if (e.keyCode === 13) {
      setQuery(e.target.value)
      effect(NInfo, EGetSearch, { query: e.target.value, categoryID })
    }
  }

  const total = num => {
    return (
      <span className="total">
        共搜索到结果<i>{num}</i>个
      </span>
    )
  }
  return (
    <div id="search">
      <div className="search">
        <Input defaultValue={keyWord} onKeyUp={e => handleKeyUp(e)} />
        <img src={require('../static/search.svg')} alt="" />
      </div>
      <div className="center">
        <div className="left">
          {searchList.data.length !== 0 ? (
            <Tabs
              onChange={value => {
                setCategoryID(value)
              }}
              defaultActiveKey="1"
              tabBarExtraContent={total(searchList.total)}
            >
              {searchCategoryCount.map(item => {
                return (
                  <TabPane tab={`${item.name}(${item.count})`} key={item.categoryID}>
                    {ArticleList(searchList.data, { total: searchList.total, pageSize: searchList.perPage }, { query, categoryID })}
                  </TabPane>
                )
              })}
            </Tabs>
          ) : (
            <Empty />
          )}
        </div>
        <div className="right">
          {HotArticle('热门帖', data)}
          {/* <div className="title">过滤选择</div>
          <h3>发布时间</h3>
          <Radio.Group name="time" defaultValue={1}>
            <Radio value={1}>一天内</Radio>
            <Radio value={2}>近一周</Radio>
            <Radio value={3}>近一月</Radio>
          </Radio.Group>

          <h3>浏览</h3>
          <Radio.Group name="view" defaultValue={1}>
            <Radio value={1}>从低到高</Radio>
            <Radio value={2}>从高到低</Radio>
          </Radio.Group>

          <h3>留言</h3>
          <Radio.Group name="comment" defaultValue={1}>
            <Radio value={1}>从低到高</Radio>
            <Radio value={2}>从高到低</Radio>
          </Radio.Group>

          <h3>点赞</h3>
          <Radio.Group name="点赞" defaultValue={1}>
            <Radio value={1}>从低到高</Radio>
            <Radio value={2}>从高到低</Radio>
          </Radio.Group> */}
        </div>
      </div>
    </div>
  )
}

export default Search
